import { analysisRolesAndOr } from "./auth";
export default (app: any) => {
  app.directive('roles', (el: any, e: any) => {
    analysisRolesAndOr(e.value) || el.remove();
  })
};